import { getApiUrl, API_URL } from '@/utils/api';
import { UntypedObject } from '@/types';

import ApiBase from './ApiBase';

export default class OrderService extends ApiBase {
  static baseUrlProducts = getApiUrl(API_URL.PRODUCT);
  static baseUrl = getApiUrl(API_URL.USER);

  getList() {
    return this.api.getJSON(`${OrderService.baseUrl}/user/ordersV2`);
  }

  get(orderId: string) {
    return this.api.getJSON(`${OrderService.baseUrl}/user/orderV2?orderId=${orderId}`);
  }

  getLastOrder() {
    return this.api.getJSON(`${OrderService.baseUrl}/order/getLastOrder`);
  }

  getProductInfos(sku: string, storeId: string) {
    return this.api.getJSON(`${OrderService.baseUrlProducts}/product/productInfos?sku=${sku}&storeId=${storeId}`);
  }

  getOrders(page?: number, sort?: any, filters: any[] = []) {
    const searchParams = new URLSearchParams();

    if (page) {
      // 0 based pagination
      searchParams.set('page', `${page}`);
    }

    if (sort?.propName) {
      searchParams.set('sort', `${sort.propName}:${sort.direction}`);
    }

    filters.filter((filter) => filter.value !== '').forEach(({ name, value }) => {
      searchParams.set(name, value);
    });

    return this.api.getJSON(`${OrderService.baseUrl}/order?${searchParams.toString()}`);
  }

  validateOrdersPayment(orders: UntypedObject) {
    return this.api.postJSON(`${OrderService.baseUrl}/order/validate-payment`, orders);
  }
}
